import { useConfiguratorStore, type WizardStep } from '@/state/configuratorStore';

export function BottomBar() {
  const product = useConfiguratorStore(s => s.product);
  const template = useConfiguratorStore(s => s.template);
  const step = useConfiguratorStore(s => s.step);
  const setStep = useConfiguratorStore(s => s.setStep);
  const capture = useConfiguratorStore(s => s.capture);

  const nextStep = Math.min(2, step + 1) as WizardStep;

  return (
    <footer className="bottombar">
      <div className="bottombar__summary">
        <strong>{product.name}</strong>
        <span className="bottombar__sep">·</span>
        <span>{template?.name ?? 'No design'}</span>
      </div>

      <div className="bottombar__actions">
        <button type="button" className="btn btn--ghost" onClick={() => void capture()}>
          Download preview
        </button>
        {step > 0 && (
          <button type="button" className="btn btn--ghost" onClick={() => setStep((step - 1) as WizardStep)}>
            Back
          </button>
        )}
        <button type="button" className="btn btn--primary" onClick={() => setStep(nextStep)}>
          {step === 0 ? 'Continue to roster' : step === 1 ? 'Continue to quote' : 'Request quote'}
        </button>
      </div>
    </footer>
  );
}
